export default {
	DROPBOX: 'DROPBOX',
	FS: 'FS',
	LOCALSTORAGE: 'LOCALSTORAGE'
};


// WEBPACK FOOTER //
// ./src/enums/file-providers.js